export default __webpack_public_path__ + "static/media/durvis-8-min.a4772466.jpg";